import { Breadcrumbs, Button, ButtonBase, Dialog, DialogContent, DialogTitle, Fade, Grow, Link, Menu, MenuItem, MenuList, Paper, Popper, TextField, Typography, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { ArrowBack, FiberManualRecordRounded, Message, Star, StarHalf, StarOutline } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import React, { useEffect, useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactImageMagnify from 'react-image-magnify';
import { openOverlayCreateMeasWithInitialization as openUniversalSizeOverlay } from '../redux/UIOverlayUniversalSizeRedux';
import { Carousel, CarouselProps } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Children } from 'react';
import { UkuranBadanSegment } from './PageProductDetailSizeOptions';
import {
  Link as RouterLink, useParams
} from "react-router-dom";
import { closeOverlayAndReset as closeOverlayAndResetSelection, openOverlay as openOverlaySelection, setValues as setValuesSelection } from '../redux/UIOverlayMeasurementSelectionViewRedux'
import { openOverlay as openOverlayMarketplaceStart } from '../redux/UIOverlayMktplcStartRedux';
import { Mixpanel } from '../mixpanel';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { CartStateItem, ProductSpotlight, RegularSizeValue, SizeType } from 'common-ts/dist/models/Cart';
import { categoryMap } from 'common-ts/dist/models/CategoryList';
import { BodyMeasCompleteForClothingType, BodyMeasurements, CalculateClothBodyMeasurementsFromBodyMeasurements, ClothingType, FitType, UserClothTypeSpecificBodyMeasurements } from 'common-ts/dist/models/UserMeasurements';
import { addItemCount, canAddProductAmountToCart, getAddToCartNextSteps, getDiscountedPriceAndTimestampInProductSpotlightList, postCanAddItemCount } from '../redux/CartRedux';
import { getCurrentSelectedMeasurement, inputMeasurementsForm, postClothingMeasurementPreference, resetLastCreatedMeasurement, resetUserMeasurementDraft, saveLocallyClothingMeasurementPreference, setKey2PreferencesMeasurement } from '../redux/MeasurementsRedux';
import { fetchNewProductId, fetchProductReviews } from '../redux/ProductReviewsRedux';
import { openOverlay, updateSignUpOrSignIn } from '../redux/UIOverlayAccountViewRedux';
import { openOverlayCreateMeasWithInitialization } from '../redux/UIOverlayMeasurementMethodSelectionViewRedux';
import { closeOverlayAndReset as closeOverlayAndResetUnivSizeCreateView, setValues as setValuesUnivSizeCreateView, openOverlay as openOverlayUnivSizeCreateView } from '../redux/UIOverlayUniversalSizeCreateMeasRedux';
import { openOverlay as openOverlaySizeChart } from '../redux/UIOverlaySizeChartRedux';
import { OfflineActiveScreen, updateCurrentScreen as updateCurrentScreenOffline, openOverlay as openOverlayOffline } from '../redux/UIOverlayOfflineRedux';
import { updateCurrentScreen } from '../redux/UIOverlayNavbarRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { FareastButton, FareastButtonWhite } from './OverlayComponentButton';
import { SignUpSignInLink } from './OverlayViewAccount';
import OptionsSlider from './PageComponentOptionsSlider';
import OptionsItemContainer from './PageComponentOptionsItemContainer';
import PageProductOverlayImageCarousel from './PageProductOverlayImageCarousel';
import PageProductOverlayNewReview from './PageProductOverlayNewReview';
import PageProductOverlaySizeChart from './PageProductOverlaySizeChart';
import { PageProductSuggestions } from './PageProductSuggestions';
import axios from 'axios';
import { RenderBlockElementProps } from './PageComponentElementBlocks';
import hash from 'object-hash';
import { sendWebsiteEventMessage, sendWebsiteLivestreamMessage } from '../telegrambotevents';
import { updateSizeChartClothFitType } from '../redux/UIOverlaySizeChartRedux';
import { getHash } from './PageOrder';
import ProductOnUser, { multiDescriptionDataExample, ProductCategory, ProductCategoryDisplayName } from 'common-ts/dist/models/Product';
import SizeSelection from './PageProductDetailSizeSelection';
import { Stack } from '@mui/material';
import StarRating from './PageComponentReviewStarRating';
import ReviewSlider from './PageComponentReviewSlider';
import ReviewSliderImage from './PageComponentReviewSliderImage';
import ReviewDialog from './PageComponentReviewDialog';
import ReviewDialogImage from './PageComponentReviewDialogImage';
import CloseIcon from '@material-ui/icons/Close';
import Countdown from 'react-countdown';
import { allowedReviewCategories, CategoryReview } from 'common-ts/dist/models/CategoryReview';
import { fetchCategoryReviewList } from '../redux/CategoryReviewRedux';
import { useInView } from 'react-intersection-observer';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import { VideoComponent } from './PageComponentElementCarousel';
import { postNewProductAnalyticsLog } from '../redux/ProductAnalyticsRedux';
import { LiveLogoMobile, marketplaceLogoDictionary } from './PageComponentElementProduct';
import PageProductDetailVariantOptions from './PageProductDetailVariantOptions';
import { openOverlayPromo } from '../redux/UIOverlayPersonalSizeRedux';
import { updateProductFamilyMediaHasViewedDict } from '../redux/ProductsListRedux';
import { ArrowRight } from '@material-ui/icons';
import { sendLivestreamMessage, setLivestreamDialog } from '../redux/LivestreamRedux';
import ReferralComponent from './ReferralView';
import { getClothBodyMeasSuggestions } from './OverlayViewUniversalSize9UkurTiapBagian';

// Offline Stuff
import CheckCircleIcon from '@material-ui/icons/CheckCircle'; // Import icon

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  productDetailRoot: {
  },
  productDetailNav: {
    paddingLeft: '20px',
    paddingRight: '30px',
    paddingTop: '0px',
    marginTop: '0px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '10px',
      marginTop: '0px',
    },
  },
  productDetailMain: { // ALLBIRDS is 18px left and right, 24px to leftmost image
    // paddingLeft: '24px',
    // paddingRight: '30px',
  },
  otherProductRecs: {
    display: 'block',
  },
  sectionDesktopAndMobile: {
    display: 'flex',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  cartContentImageContainer: { // ALLBIRDS is 6px
    width: 'auto',
    padding: '0px 20px 0px 0px',
    [theme.breakpoints.down('xs')]: {
      padding: '0px 0px 0px 0px',
    }
  },
  cartContentImage: {
    cursor: 'pointer',
  },
  stickyDetailContainer: {
    position: 'sticky',
    top: '40px',
  },
  productNameList: {
    marginBottom: '6px',
    [theme.breakpoints.up('md')]: {
      marginBottom: '6px',
    },
  },
  productPrice: {
    marginBottom: '24px',
  },
  productLeftInStock: {
    marginBottom: '16px',
  },
  productDescription: {
    marginBottom: '28px',
    marginTop: "20px",
  },
  ukuranRegulerBox: {
    marginBottom: '28px',
    marginTop: "20px",
    position: "relative",
  },
  ukuranRegulerBoxSizeChartLink: {
    position: "absolute",
    right: "0",
    top: "2px",
    fontSize: "11px",
    color: "#5e5e5e",
    textDecoration: "underline #5e5e5e solid 1px",
    cursor: "pointer",
    '-webkit-tap-highlight-color': 'transparent',
  },
  ukuranRegulerSizeTextBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "1vw",
    paddingLeft: "0.4vw",
    paddingRight: "0.4vw",
    [theme.breakpoints.down('xs')]: {
      marginTop: "4vw",
    }
  },
  ukuranRegulerSizeTextAda: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#232323",
    [theme.breakpoints.down('xs')]: {
      fontSize: "15px",
    }
  },
  ukuranRegulerSizeTextHabis: {
    fontSize: "12px",
    fontWeight: 300,
    color: "#7e7e7e",
    textDecoration: "line-through #7e7e7e solid 1px",
    [theme.breakpoints.down('xs')]: {
      fontSize: "15px",
    }
  },
  addToCartButton: {
    marginTop: '40px',
    marginBottom: '24px',
    justifyContent: 'center',
  },
  addToCartButtonText: {
    fontSize: '0.75rem', // 16px is 1 rem. 0.8 rem is 12.8px
    fontWeight: 600,
    letterSpacing: "0.03rem",
  },
  accordionStyle: {
    margin: '4px 0px !important',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  panelSummary: {
    "&.Mui-expanded": {
      minHeight: 0
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "auto"
    }
  },
  panelSummaryText: {
    "&:hover": {
      fontWeight: theme.typography.fontWeightBold as number,
      fontSize: '15px',
      textDecoration: 'underline',
    },
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: '15px',
  },
  panelContentText: {
    fontWeight: theme.typography.fontWeightLight as number,
    fontSize: '15px',
    paddingLeft: '10px',
  },
  productNameListText: {
    fontSize: '30px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
  },
  priceBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom : '24px',
  },
  productPriceText: {
    fontWeight: 'normal',
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  productPriceTextDiscount: {
    fontWeight: 'normal',
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  productPriceTextDiscountStrikeThrough: {
    fontWeight: 'normal',
    color: 'red',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '10px',
    marginTop: '2px',
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
    },
    textDecoration: 'line-through',
  },
  productLeftInStockText: {
    fontWeight: 600,
    color: '#2a2a2a',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  productDescriptionText: {
    fontWeight: 'normal',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    marginBottom: '20px',
  },
  pilihUkuranSubtext: {
    fontWeight: 'normal',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '1px',
    marginTop: '2px',
    marginBottom: '8px',
  },
  productSubtitle: {
    fontWeight: 'bold',
    color: '#121212',
    fontSize: '14px',
    marginBottom: '6px',
  },
  talentInfoText: {
    color: '#343434',
    fontSize: '13px',
    fontWeight: 400,
    fontFamily: 'Open sans, sans-serif',
    marginTop: "14px",
  },
  restockInfoText: {
    color: '#343434',
    fontSize: '13px',
    fontWeight: 400,
    fontFamily: 'Open sans, sans-serif',
    marginTop: "10px",
  },
  restockInfoTextHighlight: {
    color: '#1f1f1f',
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: 'Open sans, sans-serif',
    marginTop: "10px",
  },
  restockInfoTextIcon: {
    fontSize: '13px',
    marginRight: "9px",
  },
  chooseSizeButton: {
    width: "100%",
    paddingLeft: '20px',
    paddingRight: '24px',
    paddingTop: '9px',
    paddingBottom: '9px',
    backgroundColor: '#f1f1f1',
    marginTop: '6px',
    marginBottom: '12px',
    '&:hover': {
      backgroundColor: '#e9e9e9',
      borderColor: '#0062cc',
    },
    display: "flex",
    justifyContent: "space-between",
  },
  gantiUkuranText: {
    fontSize: "10px",
    textWrap: "nowrap",
    fontWeight: 500,
    textDecoration: "underline #121212 solid 1px",
    textUnderlineOffset: "3px",
    paddingLeft: "6px",
  },
  measurementMenuItemBody: {
    // display: 'flex',
    // justifyContent: 'space-between',
  },
  measurementMenuItem: {
    // display: 'flex',
    // justifyContent: 'space-between',
  },
  sizeText: {
    color: '#3b3b3b',
    fontSize: '12px',
    textAlign: "left",
  },
  sizeTextNewSize: {
    color: '#3b3b3b',
    fontSize: '15px',
    marginLeft: '10px',
    marginTop: '1px',
  },
  mobileViewImageCarouselContainer: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  mobileViewImageCarousel: {
    // float: 'left',
  },
  cartCarouselImageContainer: {
    padding: '0px',
  },
  cartCarouselVideoContainer: {
    position: "relative",
  },
  cartCarouselVideo: {
    width: '100%',
    paddingBottom: '36px',
  },
  cartCarouselVideoSoundButton: {
    position: "absolute",
    bottom: "52px",
    right: "16px",
    color: "#ffffff",
    backgroundColor: "#232323",
    padding: "6px 6px 4px 6px",
    borderRadius: "18px",
  },
  cartCarouselImage: {
    width: '100%',
    // objectFit: 'cover',
    // aspectRatio: '2/3',
    marginBottom: '36px',
  },
  image: {
    width: '100%',
    // objectFit: 'cover',
    // aspectRatio: '2/3',
  },
  cartCarouselContainer: {
    width: '100%',
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    marginBottom: '16px',
    position: "relative",
  },
  videoProdukBox: {
    display: 'flex',
    backgroundColor: "rgba(0.7, 0.7, 0.7, 1.0)",
    textAlign: "center",
    position: "absolute",
    bottom: "4vw",
    left: "1vw",
    width: "6vw",
    borderRadius: "1.3vw",
    zIndex: 5,
    [theme.breakpoints.down('xs')]: {
      bottom: "15.8vw",
      left: "-2.6vw",
      width: "22vw",
      borderRadius: "8vw",
      padding: '0.6vw 2vw 1.1vw 4vw',
    },
  },
  videoProdukText: {
    fontSize: "1.3vw",
    paddingTop: "0.3vw",
    color: "#ffffff",
    [theme.breakpoints.down('xs')]: {
      fontSize: "2.4vw",
      paddingTop: "1.2vw",
      margin: 'auto',
    },
  },
  sisaBox: {
    backgroundColor: "#ff1e1e",
    textAlign: "center",
    position: "absolute",
    bottom: "1vw",
    right: "1vw",
    width: "6vw",
    borderRadius: "1.3vw",
    zIndex: 5,
    [theme.breakpoints.down('xs')]: {
      bottom: "15.4vw",
      right: "3.4vw",
      width: "20vw",
      borderRadius: "8vw",
    },
  },
  sisaText: {
    fontSize: "1.3vw",
    paddingTop: "0.3vw",
    color: "#ffffff",
    [theme.breakpoints.down('xs')]: {
      fontSize: "4vw",
      paddingTop: "1.2vw",
    },
  },
  sisaBoxInDetail: {
    backgroundColor: "#ff1e1e",
    textAlign: "center",
    width: "5vw",
    borderRadius: "1.3vw",
    [theme.breakpoints.down('xs')]: {
      width: "6vw",
      display: "none",
    },
  },
  sisaTextInDetail: {
    fontSize: "1.1vw",
    paddingTop: "0.3vw",
    color: "#ffffff",
    [theme.breakpoints.down('xs')]: {
      fontSize: "1.3vw",
      display: "none",
    },
  },
  indicatorItemSelected: {
    display: 'inline-block',
    background: '#000',
    width: 8,
    height: 8,
    margin: '0px 4px',
    borderRadius: '50%',
  },
  indicatorItem: {
    display: 'inline-block',
    background: '#999',
    width: 8,
    height: 8,
    margin: '0px 4px',
    borderRadius: '50%',
  },
  limitedStockBubbleBox: {
    width: "fit-content",
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingTop: "3px",
    borderRadius: "12px",
    border: "1px solid black",
    marginBottom: "28px"
  },
  limitedStockBubbleText: {
    fontFamily: "OakesGrotesk",
    fontWeight: 500,
    fontSize: "11px",
    letterSpacing: "0.5px",
  },
  starsElementContainer: {
    display: 'flex',
    marginBottom: '6px',
  },
  starsDescriptionText: {
    fontWeight: 'normal',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    color: '#343434',
    fontFamily: 'Open sans, sans-serif',
    marginLeft: '10px',
    marginTop: '4px',
  },
  productRating: {
    marginBottom: '16px',
    [theme.breakpoints.up('md')]: {
      marginBottom: '14px',
    },
  },
  reviewsSegment: {
    margin: '0px 0px 30px 0px',
  },
  reviewsSegmentTitle: {
    margin: '40px 20px 20px 20px',
    fontWeight: theme.typography.fontWeightBold as number,
    [theme.breakpoints.up('md')]: {
      margin: '0px 40px 10px 50px',
    }
  },
  reviewsSegmentBody: {
    marginTop: '18px',
    marginBottom: '20px',
    marginLeft: '20px',
    marginRight: '20px',
    [theme.breakpoints.up('md')]: {
      marginTop: '18px',
      marginBottom: '20px',
      marginLeft: '60px',
      marginRight: '60px',
    },
  }, 
  reviewItem: {
    margin: '0px 0px 16px 0px',
    padding: '8px 2px 24px 2px',
    width: 'auto',
    borderBottom: "1px solid #dedede",

    display: 'flex',
    flexDirection: 'row',

    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px 22px 0px',
      padding: '6px 4px 28px 4px',
    },
  },
  reviewItemNew: {
    margin: '16px 10px',
    padding: '20px 20px',
    width: 'auto',
    cursor: 'pointer',
  },
  reviewDisplayPicture: {
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    padding: '10px',
    margin: '8px 18px 0px 6px',

    backgroundColor: '#d5d5d5',
    textAlign: 'center',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  reviewDisplayText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '20px',
    color: '#fff',
    marginTop: '0px',
    width: '30px' // Set to equal to display picture size
  },
  reviewItemBoxDescription: {

  },
  reviewItemBox1: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "5px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "6px",
    },
  },
  reviewItemIsVerifiedText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '11px',
    color: '#7A7A7A',
    paddingLeft: '1px',
    marginLeft: '10px', 
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
    },
  },
  reviewItemName: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '15px',
    color: "#121212",
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
    },
  },
  reviewItemBox2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: "5px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "6px",
    },
    // [theme.breakpoints.down('sm')]: {
    //   flexDirection: 'column',
    // },
  },
  reviewItemDateAndPlaceText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '11px',
    color: "#6c6c6c",
    marginBottom: '12px', 
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
  },
  reviewItemHeadline: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '15px',
    paddingLeft: '2px',
    paddingTop: '1px', 
    marginLeft: '6px', 
    marginBottom: '6px',
    color: "#121212",
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      paddingTop: '1px', 
      marginLeft: '6px', 
    },
  },
  reviewItemComment: {
    fontFamily: 'Inter',
    fontWeight: 300,
    fontSize: '15px',
    color: "#121212",
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  newReviewIcon: {
    marginLeft: '10px',
    marginBottom: '-4px'
  },
  starFilled: {
    color: '#FFA41C',
    marginLeft: '-3px',
    marginRight: '3px',
    [theme.breakpoints.down('sm')]: {
      width: '24px',
      marginLeft: '-3px',
      marginRight: '3px',
    },
  },
  starEmpty: {
    color: '#d8d8d8',
    marginLeft: '-3px',
    marginRight: '3px',
    [theme.breakpoints.down('sm')]: {
      width: '24px',
    },
  },
  roundedButtonSelected: {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '400px',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '2px',
    paddingBottom: '2px',
    margin: '4px 8px 12px 0px',
    fontWeight: 600,
    fontSize: '12px',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
    },
    border: '1px solid black',
  },
  roundedButton: {
    // color: 'white',
    borderRadius: '400px',
    color: '#727272',
    borderColor: '#727272',
    borderWidth: '1px',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '2px',
    paddingBottom: '2px',
    margin: '4px 8px 12px 0px',
    fontWeight: 600,
    fontSize: '12px',
  },
  imageBoxWidth: {
    width: '30vw',
  },
  sectionPhoto: {
    margin: '0',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    flexGrow: 0,
    maxWidth: '70%',
    flexBasis: '70%',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  sectionDescription: {
    margin: '0',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    flexGrow: 0,
    maxWidth: '30%',
    flexBasis: '30%',
    paddingLeft: '26px',
    paddingRight: '30px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  sectionDescriptionSegmentOut: {
    marginLeft: '-26px',
    marginRight: '-30px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '-20px',
      marginRight: '-20px',
    },
  },
  svgContentFullWidthDesktop: {
    marginTop: "3.3vw",
    marginBottom: "1.2vw",
    width: '100%',
  },
  svgContentFullWidthMobile: {
    width: '100%',
    marginTop: "16px",
  },

  // Style Untuk Review Haidar
  categoryReviewContainer: {
    marginBottom: '28px',
    marginTop: "42px",
    boxSizing: 'border-box',
    flex: '0 0 auto',
    flexGrow: 0,
    width: '100%',
    flexBasis: '30%',
  },
  categoryReviewContent: {
    marginBottom: '28px',
    paddingLeft: '26px',
    paddingRight: '30px',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  categoryReviewButtonContainer: {
    marginBottom: '28px',
    paddingLeft: '26px',
    paddingRight: '30px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  categoryReviewContentTitle: {
    fontWeight: 'bold',
    color: '#121212',
    fontSize: '14px',
    marginBottom: '10px',
  },
  categoryReviewContentRating:{
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center'
  },
  categoryReviewButtonSeeAll: {
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
    marginTop: 20,
    backgroundColor: '#F7F7F7',
    borderRadius: 40,
    borderWidth: '2px',
    border: 'solid #D9D9D9',
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    padding: '8px'
  },
  categoryReviewButtonSeeAllText: {
    fontWeight: 'bold',
    color: '#121212',
    fontSize: '12px',
  },
  marketplaceContainer: {
    marginTop: '10px'
  },
  marketplaceItemRowContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  exclusiveItemContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: 20,
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 0px 7px 0px'
  },
  marketplaceText: {
    fontWeight: 600,
    color: '#121212',
    fontSize: 'clamp(10px, 3vw, 14px)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.up('sm')]: {
      fontSize: 'clamp(12px, 2vw, 16px)',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 'clamp(14px, 1.5vw, 18px)',
    }
  },
  marketplaceItemContainer: {
    flex: 1,
    backgroundColor: 'transparent',
    border: '1px solid #E0E0E0',
    WebkitTapHighlightColor: "transparent",
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F5F5F5'
    },
    gap: '10px'
  },
  marketplaceLogo: {
    width: '1vw',
    [theme.breakpoints.down('xs')]: {
      width: '3.25vw'
    },
  },

  // For the Offline/Kiosk UI (TODO WIP)
    offlineBanner: {
        backgroundColor: '#e8f5e9',
        border: '1px solid #4caf50',
        borderRadius: '8px',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
        marginTop: '10px',
    },
    offlineBannerText: {
        color: '#2e7d32',
        fontWeight: 600,
        fontSize: '13px',
        marginLeft: '10px',
    },
    offlineQuickAddContainer: {
        borderTop: '1px solid #eee',
        paddingTop: '16px',
        marginTop: '16px',
    },
}),
);

interface StarsElementProps {
  stars: number
  withText?: boolean
  // colorStarFilled: string
  // colorStarEmpty: string
}

// Video Dari Page Component Element Carousel
export function determineMediaType(filename: string): string {
  const videoExtensions = ['.webm', '.mp4'];
  const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.tiff', '.svg'];

  const lowerCaseFilename = filename.toLowerCase();

  for (const extension of videoExtensions) {
    if (lowerCaseFilename.endsWith(extension)) {
      return 'video';
    }
  }

  for (const extension of imageExtensions) {
    if (lowerCaseFilename.endsWith(extension)) {
      return 'image';
    }
  }

  return 'unknown';
}

export function StarsElementRate({stars, withText,}: StarsElementProps) {
  const classes = useStyles();

  return (
    <Box className={classes.starsElementContainer}>
      {
        stars >= 1 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 0.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 2 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 1.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 3 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 2.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 4 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 3.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 5 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 4.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        withText === false ?
        null : 
        <Typography className={classes.starsDescriptionText}>
          {stars + "/5 stars"}
        </Typography>
      }
    </Box>
  )
}

export function StarsElement({stars, withText,}: StarsElementProps) {
  const classes = useStyles();

  return (
    <Box className={classes.starsElementContainer}>
      {
        stars >= 1 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 0.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 2 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 1.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 3 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 2.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 4 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 3.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        stars >= 5 ? 
        <Star className={classes.starFilled}/> : 
        stars >= 4.5 ?
        <StarHalf className={classes.starFilled}/> :
        <StarOutline className={classes.starEmpty}/>
      }
      {
        withText === false ?
        null : 
        <Typography className={classes.starsDescriptionText}>
          {stars + " / 5 stars"}
        </Typography>
      }
    </Box>
  )
}

interface ReviewElementProps {
  name: string
  isVerified: boolean
  stars: number
  creationTimestamp: string
  headline: string
  message: string
}

export function ReviewElement({name, isVerified, stars, creationTimestamp, headline, message}: ReviewElementProps) {
  const classes = useStyles();

  // Create a new JavaScript Date object based on the timestamp
  // multiplied by 1000 so that the argument is in milliseconds, not seconds.
  var date = new Date(Number(creationTimestamp) * 1000);
  // Hours part from the timestamp
  var hours = date.getHours();
  // Minutes part from the timestamp
  var minutes = "0" + date.getMinutes();
  // Seconds part from the timestamp
  var seconds = "0" + date.getSeconds();

  // Will display time in 10:30:23 format
  var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

  return (
    <Box className={classes.reviewItem}>
      <Box className={classes.reviewDisplayPicture}>
        <Typography className={classes.reviewDisplayText}>
          {name.substring(0,1)}
        </Typography>
      </Box>
      <Box className={classes.reviewItemBoxDescription}>
        <Box className={classes.reviewItemBox1}>
          <Typography className={classes.reviewItemName}>
            {name}
          </Typography>
          {
            isVerified ? 
            <Typography className={classes.reviewItemIsVerifiedText}>
              <li>Verified Purchase</li>
            </Typography> : 
            null
          }
        </Box>
        <Box className={classes.reviewItemBox2}>
          <StarsElement stars={stars} withText={false}/>
          {/* <Typography className={classes.reviewItemHeadline}>
            {headline}
          </Typography> */}
        </Box>
        <Typography className={classes.reviewItemDateAndPlaceText}>
          Reviewed on {date.toISOString().substring(0, 10)} {formattedTime}
        </Typography>
        <Typography className={classes.reviewItemComment}>
          {message}
        </Typography>
      </Box>
    </Box>
  )

}

export const countdownRendererNoText = ({ hours, minutes, seconds, completed }: any) => {

  if (completed) {
    return (
    <Box >
    </Box>);
  } else {
    return (
    <Box style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflowX: 'clip',
    }}>
      <Box style={{
        borderRadius: '20px',
        color: '#ffffff',
        backgroundColor: '#121212',
        width: 'fit-content',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Typography style={{
        fontSize: '10px',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        padding: '4px 13px 1px 14px',
        backgroundColor: '#e10000',
        borderRadius: '20px',
        letterSpacing: '0.6px',
      }}>
        SALE
      </Typography>
      <Typography style={{
        fontSize: '10px',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        padding: '4px 14px 1px 10px',
      }}>
        {
          hours && Number(hours) > 0 ? 
          String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0') :
          String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
        }
      </Typography>
      </Box>
    </Box>)
  }
};

export const countdownRenderer = ({ hours, minutes, seconds, completed }: any) => {

  if (completed) {
    return (
    <Box >
    </Box>);
  } else {
    return (
    <Box style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflowX: 'clip',
    }}>
      <Box style={{
        borderRadius: '20px',
        color: '#ffffff',
        backgroundColor: '#121212',
        width: 'fit-content',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Typography style={{
        fontSize: '10px',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        padding: '4px 13px 1px 14px',
        backgroundColor: '#e10000',
        borderRadius: '20px',
        letterSpacing: '0.6px',
      }}>
        SALE
      </Typography>
      <Typography style={{
        fontSize: '10px',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        padding: '4px 14px 1px 10px',
      }}>
        {
          hours && Number(hours) > 0 ? 
          String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0') :
          String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
        }
      </Typography>
      </Box>
      <Typography style={{
        fontSize: '10%',
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        padding: '4px 0px 1px 8px',
        color: '#121212'
      }}>
        WEBSITE ONLY
      </Typography>
    </Box>)
  }
};

export const countdownRendererImgFullwidth = (imgSrc: string) => {
  return (({ hours, minutes, seconds, completed }: any) => {

  if (completed) {
    return (
    <Box >
    </Box>);
  } else {
    return (
    <Box style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflowX: 'clip',
      position: 'relative',
      containerType: 'inline-size',
    }}>
      <img src={imgSrc} style={{width: '100%'}}/>
      <Typography style={{
        fontSize: '3.7cqw',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        position: 'absolute',
        right: '5.3cqw',
        top: '3.95cqw',
        color: '#ffffff'
      }}>
        {
          hours && Number(hours) > 0 ? 
          String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0') :
          String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
        }
      </Typography>
    </Box>)
  }
})
};


export const countdownRendererImgHalfwidth = (imgSrc: string) => {
  return (({ hours, minutes, seconds, completed }: any) => {

  if (completed) {
    return (
    <Box >
    </Box>);
  } else {
    return (
    <Box style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflowX: 'clip',
      position: 'relative',
      containerType: 'inline-size',
    }}>
      <img src={imgSrc} style={{width: '100%'}}/>
      <Typography style={{
        fontSize: '5.4cqw',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        position: 'absolute',
        right: '6.85cqw',
        top: '7.48cqw',
        color: '#ffffff'
      }}>
        {
          hours && Number(hours) > 0 ? 
          String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0') :
          String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
        }
      </Typography>
    </Box>)
  }
})
};

function ReviewComponent({ratingNumber, ratingValue, categoryName}: {ratingNumber: number | undefined, ratingValue: number | undefined, categoryName: string}) {
  const classes = useStyles();

  return (
    <Stack 
      direction='row' 
      className={classes.categoryReviewContentRating}
      style={{
        marginBottom: '3px',
      }}
    >
      <StarRating productRating={ratingValue ? ratingValue : 5} gap={'0.5vw'} mt={0.4} />
      <Typography variant="body1">
        <Typography variant="body1" style={{fontWeight: 600, color: '#232323', fontSize: '14px'}} component='span'>
          {ratingValue} / 
        </Typography>
        <Typography variant="body1" style={{fontWeight: '300', fontSize: '12px'}} component='span'>
          {' 5.0'}
        </Typography>
      </Typography>
      <Box style={{paddingTop: '4px'}}>
        <Typography variant="body2" style={{fontWeight: '400', fontSize: '10px', color: '#9B9B9B'}} >
          {ratingNumber} REVIEWS <br/>({categoryName})
        </Typography>
      </Box>
    </Stack>
  )
}

interface MarketplaceLinkData {
  [key: string]: string;
}

const marketplaceLinkDataDefault: MarketplaceLinkData = {
  shopee: "https://shopee.co.id/studios_id",
  tokopedia: "https://tokopedia.com/studiosid",
  tiktok: "https://tiktok.com"
};

export default function PageProductDetail() {
  let { productId } = useParams<{ productId: string }>();
  productId = decodeURIComponent(productId); // We decode product URI
  const productDict = useAppSelector(state => state.productsList.productsDictionary);
  const productDetail = productDict[productId];

  const productFamilyMediaHasViewedDict = useAppSelector(state => state.productsList.productFamilyMediaHasViewedDict);

  const streamIsOn = useAppSelector((state) => state.livestreamState.streamIsOn);

  const userPrefDict = useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsPreferenceDictionary);
  const userBodyMeasurementsDictionary = useAppSelector(state => state.userMeasurementsList.userBodyMeasurementsDictionary);
  const userClothingMeasurementsDictionary = useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsDictionary);
  const hasUkuranPersonal = Object.keys(userBodyMeasurementsDictionary).length > 0;

  const clothMeasSuggestions = useAppSelector(state => getClothBodyMeasSuggestions(state.ordersList.ordersList));

  const lastCreatedMeasurement = useAppSelector(state => state.userMeasurementsList.lastCreatedMeasurement);
  const productSizeAvailabilityDict = useAppSelector(state => state.productsList.productSizeAvailabilityDict);
  const numberOfItemsRemaining = productSizeAvailabilityDict?.[productId]?.numberOfItemsRemaining ?? 0;
  const isSignedIn = useAppSelector(state => state.account.authState === 'signedin');
  const cart = useAppSelector(state => state.cart);
  const userIsSignedInAndHasPurchased = useAppSelector(state => state.account.authState === 'signedin' && (state?.account.paidOrderCount ?? 0) >= 1);

  const postMeasurementStatus = useAppSelector(state => state.userMeasurementsList.postMeasurementStatus);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const isSoldOut = productDetail?.isSoldOut || numberOfItemsRemaining === 0;

  const authState = useAppSelector(state => state.account.authState);

  const productReviewsState = useAppSelector(state => state.productReviews);

  const [selectedReviewTab, setSelectedReviewTab] = React.useState<number>(0);

  const [startImageOverlayIndex, setStartImageOverlayIndex] = React.useState<number>(0);
  const [imageOverlayIndex, setImageOverlayIndex] = React.useState<number>(0);
  const [imageOverlayOpen, setImageOverlayOpen] = React.useState<boolean>(false);

  const [newReviewOverlayOpen, setNewReviewOverlayOpen] = React.useState<boolean>(false);

  // State Review Haidar
  const productCategoryReviewState = useAppSelector(state => state.categoryReviewList)
  const productCategoryReviewRecap = useAppSelector(state => state.categoryReviewList.categoryReviewRecap);
  const productCategoryReviewDict = useAppSelector(state => state.categoryReviewList.categoryReviewListDict);
  const [openDialogReviewImage, setDialogOpenReviewImagDialog] = React.useState(false);
  const [openDialogSeeAllReview, setOpenDialogSeeAllReview] = React.useState(false);
  const [selectedReviewIndex, setSelectedReviewIndex] = React.useState<number>(0);
  const [selectedImageIndex, setSelectedImageIndex] = React.useState<number>(0);

  const [lastRenderTime, setLastRenderTime] = React.useState<string>('');
  const nextAutoslideTime = useRef(new Date().toISOString());
  const [productImagesListSet, setProductImagesListSet] = React.useState<string[]>([]);

  const productCategoryForReview = productDetail && allowedReviewCategories[productDetail.category] ? productDetail.category : 'all';
  const productCategoryForReviewName = productCategoryForReview === 'all' ? 
  'SEMUA PRODUK' : 
  ProductCategoryDisplayName[productCategoryForReview].toUpperCase();

  const productCategoryReviewList = productCategoryReviewDict[productCategoryForReview]?.categoryReviewList ?? [];
  const sortedProductCategoryReviewList = sortProductCategoryReviewList(productCategoryReviewList ? [...productCategoryReviewList] : [])
  const fullReviewList = sortedProductCategoryReviewList.length > 0 ? sortedProductCategoryReviewList : productCategoryReviewList;
  const shortenedReviewList = fullReviewList.slice(0, 50); // Set a max of 50 reviews to avoid too heavy rendering

  const isInsideIframe = window.self !== window.top

  useEffect(() => {
    if (!productDetail) {
      setProductImagesListSet([]);
      setStartImageOverlayIndex(0);
      setImageOverlayIndex(0);
    }
    if (productDetail) {
      // var newProductImagesList = [productDetail.productImages[0], 
      //   "https://studiosclo.uk/general/VideoProdukWorkShirt_7_sub.mp4_familymedia"].concat(productDetail.productImages.slice(1));
      var newProductImagesList = productDetail.productImages;

      // Reorder new product images list
      newProductImagesList = (newProductImagesList.filter((urlItem) => productFamilyMediaHasViewedDict[urlItem]))
        .concat(newProductImagesList.filter((urlItem) => productFamilyMediaHasViewedDict[urlItem] !== true));

      setProductImagesListSet(newProductImagesList);

      const startIndex = newProductImagesList?.filter((urlItem) => productFamilyMediaHasViewedDict[urlItem])?.length ? 
        newProductImagesList?.filter((urlItem) => productFamilyMediaHasViewedDict[urlItem])?.length : 0;
      setStartImageOverlayIndex(startIndex);
      setImageOverlayIndex(startIndex);

      // if (newProductImagesList.filter((urlItem) => urlItem.endsWith("_familymedia"))?.length) {
      //   (window as any).hj('event', 'start_hotjar_rec'); // START HOTJAR REC
      // }
      
      const intervalId = setInterval(() => {
        const curTime = new Date().toISOString();
        if (curTime > nextAutoslideTime.current) {
          setImageOverlayIndex((imageOverlayIndex) => ((imageOverlayIndex + 
            (newProductImagesList?.[imageOverlayIndex]?.includes("mp4") ? 0 : 1)) % newProductImagesList.length));
        }
      }, 4300);
      if ((window as any).fbq !== null) { 
        (window as any).fbq('track', 'ViewContent', {
          content_ids: [productDetail.productId],
          content_type: 'product',
          contents: [{
            id: productDetail.productId,
            quantity: 1,
          }],
          currency: "IDR",
          value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
        });
      }

      if (
        productCategoryReviewState.getStatus !== APIRequestStatus.RequestInProgress
      ) {
        dispatch(fetchCategoryReviewList(productCategoryForReview));
      }

      return () => clearInterval(intervalId); // This is important
    }
  }, [productDetail]);

  // Analytics
  useEffect(() => {
    dispatch(postNewProductAnalyticsLog({event: 'VISIT', productId: productId, isMobileView: !isDesktop})) // We'll just default to shop
  }, [productId]);
  useEffect(() => {
    const img = new Image();
    img.src = 'https://studiosclo.uk/general/MEAS_KIT_BANNER.png';
  }, [])

  // If product detail is still loading, we return null
  if (productDetail === undefined) {
    return null;
  }

  let combinedProductSpotlightList: ProductSpotlight[] = (cart?.productSpotlightList?.length ? cart.productSpotlightList : []).concat(cart.coupon?.couponProductSpotlightList?.map((prodObj) => ({
    ...prodObj,
    timestampStart: '1999-10-10T00:00:00.000Z',
    timestampLimit: cart.coupon?.expirationDateTime ?? '1999-10-10T00:00:00.000Z', 
    isMainSpotlight: false,
    alternativeSource: 'COUPON'
  })) ?? []);
  let activeSpotlightPromo = cart.coupon?.couponBlastingEffects?.length ? {
    discountedPrice: Math.round((1 - cart.coupon?.couponBlastingEffects?.[0].effectValue) * (productDetail.originalPrice)),
    timestampStart: '1999-10-10T00:00:00.000Z',
    timestampLimit: cart.coupon?.expirationDateTime ?? '1999-10-10T00:00:00.000Z', 
    isMainSpotlight: false,
    alternativeSource: 'COUPON'
  } : getDiscountedPriceAndTimestampInProductSpotlightList(combinedProductSpotlightList, productId);

  let spotlightDiscPrice = activeSpotlightPromo.discountedPrice;
  let discountedPrice = spotlightDiscPrice !== -1 ? spotlightDiscPrice : productDetail.discountedPrice;
 
  let originalPrice = productDetail.originalPrice;

  // BUNDLING ADDITION: OVERWRITES ANYTHING ELSE
  if (productDetail.bundlingData) {
    originalPrice = productDetail.bundlingData.bundlingPrice1;
  }

  let productSpotlightTime = activeSpotlightPromo.timestampLimit;
  let spotlightSource = activeSpotlightPromo?.alternativeSource ?? "FLASHSALE";

  // We set fitType to the default fit type
  const clothingType = productDetail.clothingType;
  const fitType: FitType = productDetail.defaultFitType ? productDetail.defaultFitType : productDetail.fitTypes[0];
  const key2 = clothingType + "-" + fitType;

  let {
    currentSelectedMeasurement,
    currentSelectedMeasurementId,
    currentSelectedMeasurementIsBody,
    key2DefaultSelectedMeasurementCanBeSet,
    key2DefaultSelectedMeasurementCanBeSetRecommended
  } = getCurrentSelectedMeasurement(key2, userPrefDict, userBodyMeasurementsDictionary, userClothingMeasurementsDictionary);

  // console.log("Current selected measurement:", currentSelectedMeasurement);

  // AUTO MEASUREMENT ASSIGNMENT IF CONDITIONS ARE MET
  if (key2DefaultSelectedMeasurementCanBeSet && key2DefaultSelectedMeasurementCanBeSetRecommended) {
    dispatch(setKey2PreferencesMeasurement(key2));
  }

  var reviewProductId = productDetail.parentProductId ? productDetail.parentProductId : productId;
  if (productReviewsState.productId + "" !== reviewProductId + "" && productReviewsState.getStatus !== APIRequestStatus.RequestInProgress) {
    console.log("Fetch reviews for product " + productId + " which has parent " + reviewProductId);
    dispatch(fetchNewProductId(reviewProductId));
    dispatch(fetchProductReviews(reviewProductId));
  }

  // Marketplace Link
  const marketplaceLinkData = productDetail?.marketplaceLinkData || {}
  const marketplaceLinkDataList = Object.keys(marketplaceLinkData)

  // Product Variants
  const productVariantsList = productDetail?.productVariantsList

  var cartStateItem: CartStateItem = {
    productId: productId,
    amount: 1,
    clothingType: productDetail.clothingType,
    fitType: fitType,
    sizeType: SizeType.personal, // "personal" or "regular"
    measurementCreationDateTime: "NOTSELECTED",
    measurementUpdateDateTime: "NOTSELECTED",
    measurementIsBodyMeasurement: false,
    regularSize: RegularSizeValue.NOTSELECTED,
  };

  var hashCartStateItem = '';

  if (currentSelectedMeasurement) {
    if (currentSelectedMeasurement.sizeType === 'personal') {
      cartStateItem.sizeType = SizeType.personal;
      cartStateItem.measurementCreationDateTime = currentSelectedMeasurement.creationDateTime as string;
      cartStateItem.measurementUpdateDateTime = currentSelectedMeasurementIsBody ? 'LATEST' : currentSelectedMeasurement.updateDateTime as string;
      cartStateItem.measurementIsBodyMeasurement = currentSelectedMeasurementIsBody;
      cartStateItem.regularSize = currentSelectedMeasurement.regularSize as RegularSizeValue ? currentSelectedMeasurement.regularSize as RegularSizeValue : RegularSizeValue.NOTSELECTED;
    } else if (currentSelectedMeasurement.sizeType === 'regular') {
      cartStateItem.sizeType = SizeType.regular;
      cartStateItem.measurementCreationDateTime = "NOTSELECTED";
      cartStateItem.measurementUpdateDateTime = "NOTSELECTED";
      cartStateItem.measurementIsBodyMeasurement = currentSelectedMeasurementIsBody;
      cartStateItem.regularSize = currentSelectedMeasurement.regularSize as RegularSizeValue;
    }

    hashCartStateItem = hash(cartStateItem);

    if (cart.canAddItemDict[hashCartStateItem] === undefined) {
      dispatch(postCanAddItemCount(cartStateItem));
    }
  }

  // Change the button text according to the state of the product
  var productPurchaseStage;
  if (currentSelectedMeasurement === undefined) {
    productPurchaseStage = "PILIH_UKURAN";
  } else if (hashCartStateItem === undefined) {
    productPurchaseStage = "UNDEFINED_ITEM";
  } else if (cart.canAddItemDict[hashCartStateItem] === "LOADING") {
    productPurchaseStage = "CHECKING_STOCK";
  } else if ((cart.canAddItemDict[hashCartStateItem] as any)?.canBeProvisioned) {
    productPurchaseStage = "ADD_TO_CART";
    if (lastCreatedMeasurement && currentSelectedMeasurementId === lastCreatedMeasurement) { // Auto add to cart, to be done once per creation.
      if (cartStateItem.sizeType === 'personal') {
        dispatch(addItemCount({
          productId: productId,
          productDetail: productDetail,
          fitType: fitType,
          sizeType: cartStateItem.sizeType,
          measurementCreationDateTime: currentSelectedMeasurement.creationDateTime as string,
          measurementUpdateDateTime: currentSelectedMeasurementIsBody ? 'LATEST' : currentSelectedMeasurement.updateDateTime as string,
          measurementIsBodyMeasurement: currentSelectedMeasurementIsBody,
          regularSize: cartStateItem.regularSize ? cartStateItem.regularSize : RegularSizeValue.NOTSELECTED,
        }));
        // Auto-add (item lands in cart after measurement creation) is a real add-to-cart, so
        // it must emit ADD-TO-CART for scoring — mirrors the manual button at the ATC dispatch
        // below. 2h dedup in the thunk absorbs any overlap with the earlier size-bar SELECT-SIZE.
        dispatch(postNewProductAnalyticsLog({event: 'ADD-TO-CART', productId: productId, isMobileView: !isDesktop }))
        window.parent.postMessage({ type: "add_to_cart", payload: {itemId: productId } }, '*');
        if (!isInsideIframe) {
          dispatch(updateCurrentScreen("CART"));
        }
      } else if ((cartStateItem.sizeType === 'regular')) {
        dispatch(addItemCount({
          productId: productId,
          productDetail: productDetail,
          fitType: fitType,
          sizeType: cartStateItem.sizeType,
          measurementCreationDateTime: 'NOTSELECTED',
          measurementUpdateDateTime: 'NOTSELECTED',
          measurementIsBodyMeasurement: currentSelectedMeasurementIsBody,
          regularSize: cartStateItem.regularSize,
        }));
        // Auto-add (regular size) is a real add-to-cart — emit ADD-TO-CART for scoring, same as
        // the manual button. 2h dedup absorbs overlap with the earlier size-bar SELECT-SIZE.
        dispatch(postNewProductAnalyticsLog({event: 'ADD-TO-CART', productId: productId, isMobileView: !isDesktop }))
        window.parent.postMessage({ type: "add_to_cart", payload: {itemId: productId } }, '*');
        if (!isInsideIframe) {
          dispatch(updateCurrentScreen("CART"));
        }
      }
      dispatch(resetLastCreatedMeasurement());
    }
  } else if ((cart.canAddItemDict[hashCartStateItem] as any)?.canBeProvisioned === false && 
    (cart.canAddItemDict[hashCartStateItem] as any)?.isServiceable){
    // console.log((cart.canAddItemDict[hashCartStateItem] as any));
    productPurchaseStage = "OUT_OF_STOCK";
    if (lastCreatedMeasurement && currentSelectedMeasurementId === lastCreatedMeasurement) { // Auto add to cart, to be done once per creation.
      dispatch(resetLastCreatedMeasurement());
    }
  } else if ((cart.canAddItemDict[hashCartStateItem] as any)?.canBeProvisioned === false && 
    !(cart.canAddItemDict[hashCartStateItem] as any)?.isServiceable){
    // console.log((cart.canAddItemDict[hashCartStateItem] as any));
    productPurchaseStage = "NOT_SERVICEABLE";
    if (lastCreatedMeasurement && currentSelectedMeasurementId === lastCreatedMeasurement) { // Auto add to cart, to be done once per creation.
      dispatch(resetLastCreatedMeasurement());
    }
  }

  // Fungsi Review Haidar
  const handleOpenDialogSeeAllReview = () => {
    setOpenDialogSeeAllReview(true);
  };
  const handleCloseDialogSeeAllReview = () => {
    setOpenDialogSeeAllReview(false);
  };

  const handleOpenDialogReviewImage = (reviewIndex: number, imageIndex: number) => {
    setSelectedReviewIndex(reviewIndex);
    setSelectedImageIndex(imageIndex);
    setDialogOpenReviewImagDialog(true);
  };

  const handleCloseDialogReviewImage = () => {
    setDialogOpenReviewImagDialog(false);
  };

  const handleOpenDialogReviewImageFromReviewDialog = (reviewIndex: number, imageIndex: number) => {
    handleOpenDialogReviewImage(reviewIndex, imageIndex)
    handleCloseDialogSeeAllReview()
  }

  const productImagesList = productImagesListSet?.length ? productImagesListSet : productDetail?.productImages ? productDetail.productImages : [];

  const handleClickSizeBar = () => {
    if (currentSelectedMeasurement === undefined) {
      if ((window as any).fbq !== null) { 
        (window as any).fbq('trackCustom', 'CreateSize', {
          currency: "IDR",
          value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
        })
      }
      if ((window as any).fbq !== null) { 
        (window as any).fbq('trackCustom', 'CreateSizeOrAddToCart', {
          currency: "IDR",
          value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
        })
      };

      if ((window as any).fbq !== null) { 
        (window as any).fbq('track', 'AddToCart', {
          content_ids: [productDetail.productId],
          content_type: 'product',
          contents: [{
            id: productDetail.productId,
            quantity: 1,
          }],
          currency: "IDR",
          value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
        })
      };

      sendWebsiteEventMessage("Ada yang click pilih ukuran dari reguler. Product: " + productDetail.name);

      dispatch(postNewProductAnalyticsLog({event: 'SELECT-SIZE', productId: productId, isMobileView: !isDesktop }))

      dispatch(openOverlayCreateMeasWithInitialization({
        clothingType: clothingType,
        fitType: fitType,
        productDetail: productDetail,
        addToCartAfterCreation: true,
      }));
      return;
    } else {
      const element = document.getElementById("size-reguler-list");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
    }
  };

  const handleAddToCartMainButton = () => {
    (window as any).dataLayer.push({'event': 'cartAddItemOrSizeCreateNew', 'productId': "productId-" + productId});
    Mixpanel.track('cartAddItemOrSizeCreateNew', {
      'productId': "productId-" + productId,
    });
    if ((window as any).fbq !== null) { 
      (window as any).fbq('trackCustom', 'CreateSizeOrAddToCart', {
        currency: "IDR",
        value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
      })
    };

    if ((window as any).fbq !== null) { 
      (window as any).fbq('track', 'AddToCart', {
        content_ids: [productDetail.productId],
        content_type: 'product',
        contents: [{
          id: productDetail.productId,
          quantity: 1,
        }],
        currency: "IDR",
        value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
      })
    };

    // OPEN OVERLAY IN OFFLINE CASE, WHEN IT IS IN IFRAME
    if (currentSelectedMeasurement === undefined && isInsideIframe) {
      window.parent.postMessage({ type: "START_MEASUREMENT_PROCESS" }, "*");
      return;
    }

    if (currentSelectedMeasurement === undefined) {
      if ((window as any).fbq !== null) { 
        (window as any).fbq('trackCustom', 'CreateSize', {
          currency: "IDR",
          value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
        })
      }
      (window as any).dataLayer.push({'event': 'sizeCreateNew'});
      Mixpanel.track('sizeCreateNew', {
        'productId': "productId-" + productId,
        'signedIn': authState === 'signedin' ? 'true' : 'false',
        'source': 'productPageAddToCartButton',
      });
      console.log("Tracking mixpanel sizeCreateNew for product " + productId);

      sendWebsiteEventMessage("Ada yang click pilih ukuran. Product: " + productDetail.name);

      dispatch(postNewProductAnalyticsLog({event: 'SELECT-SIZE', productId: productId, isMobileView: !isDesktop }))

      const sizeData = {
        clothingType: clothingType,
        fitType: fitType,
        productDetail: productDetail,
        addToCartAfterCreation: true,
      };
      dispatch(openOverlayCreateMeasWithInitialization(sizeData));

      return;
    }

    // SELECT-SIZE kept for continuity (historical ATC proxy); ADD-TO-CART is the clean
    // mid-funnel signal for product scoring (fires only when an item actually lands in cart).
    dispatch(postNewProductAnalyticsLog({event: 'SELECT-SIZE', productId: productId, isMobileView: !isDesktop }))
    dispatch(postNewProductAnalyticsLog({event: 'ADD-TO-CART', productId: productId, isMobileView: !isDesktop }))

    sendWebsiteEventMessage("Ada yang click add to cart. Product: " + productDetail.name);

    (window as any).dataLayer.push({'event': 'cartAddItem', 'productId': "productId-" + productId});
    Mixpanel.track('cartAddItem', {
      'productId': "productId-" + productId,
    });
    console.log("Tracking mixpanel cartAddItem for product " + productId);

    if (cartStateItem.sizeType === 'personal') {
      dispatch(addItemCount({ 
        productId: productId, 
        productDetail: productDetail,
        fitType: fitType,
        sizeType: cartStateItem.sizeType,
        measurementCreationDateTime: currentSelectedMeasurement.creationDateTime as string,
        measurementUpdateDateTime: currentSelectedMeasurementIsBody ? 'LATEST' : currentSelectedMeasurement.updateDateTime as string,
        measurementIsBodyMeasurement: currentSelectedMeasurementIsBody,
        regularSize: cartStateItem.regularSize ? cartStateItem.regularSize : RegularSizeValue.NOTSELECTED,
      }));
      dispatch(updateCurrentScreen("CART"));
    } else if ((cartStateItem.sizeType === 'regular')) {
      dispatch(addItemCount({ 
        productId: productId, 
        productDetail: productDetail,
        fitType: fitType,
        sizeType: cartStateItem.sizeType,
        measurementCreationDateTime: 'NOTSELECTED',
        measurementUpdateDateTime: 'NOTSELECTED',
        measurementIsBodyMeasurement: currentSelectedMeasurementIsBody,
        regularSize: cartStateItem.regularSize,
      }));
      dispatch(updateCurrentScreen("CART"));
    }
  };

  return (
    <Box className={classes.productDetailRoot}>
      <Box className={classes.cartCarouselContainer}>
        <Carousel
          selectedItem={imageOverlayIndex}
          preventMovementUntilSwipeScrollTolerance={true}
          swipeScrollTolerance={12}
          onSwipeStart={() => {
            const autoslideFreezeTime = 9; // In seconds
            nextAutoslideTime.current = new Date(new Date().getTime() + (autoslideFreezeTime * 1000)).toISOString();
          }}
          infiniteLoop={true}
          showThumbs={false} 
          showStatus={false}
          showArrows={false}
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            if (isSelected) {
              return (
                <li
                  className={classes.indicatorItemSelected}
                  aria-label={`Selected: ${label} ${index + 1}`}
                  title={`Selected: ${label} ${index + 1}`}
                >

                </li>
              );
            }
            return (
              <li
                className={classes.indicatorItem}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                title={`${label} ${index + 1}`}
                aria-label={`${label} ${index + 1}`}
              >
              </li>
            );
          }}
          onChange={ (index, item) => {
            if (productImagesList[index].endsWith("_familymedia")) {
              dispatch(updateProductFamilyMediaHasViewedDict([productImagesList[index]]))
            }
            if (imageOverlayIndex !== index) {
              setImageOverlayIndex(index);
              Mixpanel.track('fullscreenImageSlide', {
                'index': index,
                'productId': "productId-" + productId,
              });
            }
          }}
          >
          {
            productImagesList.map((urlImg) => urlImg.replace('_familymedia', '').replace('.jpg', '').replace('.jpeg', '') + (urlImg.includes('mp4') ? '' : '_1080.jpg')).map((item, i) => {
              let contentType = determineMediaType(item);

              if (contentType === "image") {
                return (
                  <div 
                    key={"img-product-" + productId + i }
                    onClick={() => {
                        setImageOverlayOpen(true);
                        Mixpanel.track('fullscreenImageOpen', {
                          'productId': "productId-" + productId,
                        });
                      }}>
                  <img src={item} className={classes.cartCarouselImage}/>
                </div>
                );
              } else if (contentType === "video") {
                return (
                  <div 
                  key={"img-product-" + productId + i }
                  onClick={() => {
                      setImageOverlayOpen(true);
                    }}>
                    <VideoComponent 
                      source={item} 
                      videoHasSound={item?.includes("_with_sound")}
                      videoSoundOn={item?.includes("_with_sound") && imageOverlayOpen === false && imageOverlayIndex === i}
                    />
                  </div>
                );
              } else {
                return (
                  <div 
                  key={"img-product-" + productId + i }>
                    <img src={item} className={classes.cartCarouselImage} />
                  </div>
                );
              }
            }).filter(Boolean)
          }
        </Carousel>
        {
          startImageOverlayIndex > 0 && imageOverlayIndex >= startImageOverlayIndex ?
          <Box className={classes.videoProdukBox}
          onClick={() => {
            setImageOverlayIndex(0);
          }}>
            <ArrowRight style={{
              color: '#ffffff',
              margin: '-0.1em 0em -0.1em -0.1em',
            }}/>
            <Typography className={classes.videoProdukText}>
              Video Produk
            </Typography>
          </Box>:
          null
        }
        {
          !isSoldOut && numberOfItemsRemaining && numberOfItemsRemaining < 14 ?
          <Box className={classes.sisaBox}>
            <Typography className={classes.sisaText}>
              Sisa {numberOfItemsRemaining}
            </Typography>
          </Box>:
          null
        }
      </Box>
      <Box className={classes.productDetailMain}>
        <Grid container>
          {/* Buat Desktop Ternyata */}
          {
            isDesktop ? 
          <Box className={classes.sectionPhoto}>
            <OptionsSlider
              title={[]}
              buttonMarginRight='24px'
              contentsChange={productId}
              contents={
                productImagesList.map((urlImg) => urlImg.replace('_familymedia', '').replace('.jpg', '').replace('.jpeg', '') + (urlImg.includes('mp4') ? '' : '_1080.jpg')).map((item, i) => {
                  let contentType = determineMediaType(item);

                  return (
                    <OptionsItemContainer
                    xsSize={6}
                    smSize={6}
                    mdSize={6}
                    lgSize={6}
                    content={
                      <div className={classes.cartContentImageContainer}
                        onClick={() => {
                          Mixpanel.track('fullscreenImageOpen', {
                            'productId': "productId-" + productId,
                          });
                          if (imageOverlayIndex !== i) {
                            setImageOverlayIndex(i);
                            Mixpanel.track('fullscreenImageSlide', {
                              'index': i,
                              'productId': "productId-" + productId,
                            });
                          }
                          setTimeout(() => {
                            setImageOverlayOpen(true);
                          }, 250);
                        }}>
                          {
                            contentType === "image" ?
                            <ReactImageMagnify {...{
                              smallImage: {
                                alt: 'Wristwatch by Ted Baker London',
                                isFluidWidth: true,
                                src: item,
                              },
                              largeImage: {
                                src: item,
                                width: 720,
                                height: 1080,
                              }
                            }} 
                            enlargedImagePosition="over"
                            isHintEnabled={ i === 1 ? true : false} />:
                            contentType === "video" ?
                            <VideoComponent 
                              source={item} 
                              videoHasSound={item?.includes("_with_sound")}
                              videoSoundOn={item?.includes("_with_sound") && imageOverlayOpen === false && imageOverlayIndex === i}
                            />:
                            <div></div>
                          }
                      </div>
                    }/>)})
                }
              marginDesktop='0px 0px 0px 0px'
              marginMobile='0px 0px 0px 0px'
            />
          </Box>: null
          }
          <Box className={classes.sectionDescription} >
              {
                (new Date().toISOString() < productSpotlightTime) &&
                <Box style={{margin: isDesktop ? '10px 0px 15px 0px' : '0px 0px 15px 0px'}}>
                  <Countdown
                    date={productSpotlightTime}
                    renderer={spotlightSource === "COUPON" && cart?.coupon?.couponFullWidthCountdownMedia ? countdownRendererImgFullwidth(cart.coupon.couponFullWidthCountdownMedia) : countdownRenderer}
                    onComplete={(timeDelta, completedOnStart) => {
                      setTimeout(() => {
                        setLastRenderTime(new Date().toISOString())
                      }, 400)
                    }}
                  />
                </Box>
              }
              {
                streamIsOn &&
                <Box style={{
                  borderRadius: '300px',
                  border: '1px solid rgb(200, 200, 200)',
                  cursor: 'pointer',
                  margin: isDesktop ? '8px 0px 12px' : '-14px 0px 16px',
                  padding: '4px 8px 4px 5px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'relative',
                  // width: 'fit-content',
                }} onClick={() => {
                  dispatch(sendLivestreamMessage("UD-User minta lihat produk (detail) " + productDetail.name));
                  dispatch(setLivestreamDialog('LIVE'));
                }}>
                  <LiveLogoMobile/>
                  <Typography style={{padding: '1px 5px 0px 5px', fontSize: '12px', letterSpacing: '0.2px', fontWeight: 600}}>MINTA LIHAT PRODUK</Typography>
                  <ArrowRight style={{marginLeft: '-8px', paddingBottom: '2px'}}/>
                </Box>
              }
              <Typography className={classes.productNameListText} style={{marginBottom: '1px'}} onClick={() => {
                  // dispatch(openOverlayPromo({
                  //   sizeData: {
                  //     clothingType: clothingType,
                  //     fitType: fitType,
                  //     productDetail: productDetail,
                  //     addToCartAfterCreation: true,
                  //   },
                  //   productDetail: productDetail ?? undefined,
                  // }));
                }}>
                <b>{ReactHtmlParser(productDetail.name)}</b>
              </Typography>

              {/* SHOW INJECTED MEASUREMENT BANNER */}
              {/*isOfflineSession && (
                  <Fade in={true} timeout={1000}>
                      <Box className={classes.offlineBanner}>
                          <CheckCircleIcon style={{ color: '#4caf50' }} />
                          <Box>
                              <Typography className={classes.offlineBannerText}>
                                  Ukuran Tubuh Terdeteksi
                              </Typography>
                              <Typography style={{ fontSize: '11px', color: '#4caf50', marginLeft: '10px' }}>
                                  Menggunakan data ukur {currentSelectedMeasurement?.nama ?? "Kamu"}.
                              </Typography>
                          </Box>
                      </Box>
                  </Fade>
              )*/}

              <div onClick={() => {
                const element = document.getElementById("product-review-container");

                if (element) {
                  element.scrollIntoView({behavior: "smooth", block: isDesktop ? "end" : "center"});
                }
              }} style={{
                cursor: 'pointer',
                WebkitTapHighlightColor: 'transparent'
              }}>
              <ReviewComponent 
                ratingNumber={productCategoryReviewRecap[productCategoryForReview]?.numberOfRatings} 
                ratingValue={productCategoryReviewRecap[productCategoryForReview]?.averageRating}
                categoryName={productCategoryForReviewName}
              />
              </div>

              {
                productDetail.bundlingData &&
                !isSoldOut && numberOfItemsRemaining && numberOfItemsRemaining < 14 ?
                <Box className={classes.sisaBoxInDetail} style={{marginTop: '8px', marginBottom: '9px'}}>
                  <Typography className={classes.sisaTextInDetail}>
                    Sisa {numberOfItemsRemaining}
                  </Typography>
                </Box>:
                null
              }

              {
                productDetail.bundlingData ?
                <>
                <Box className={classes.priceBox} style={{marginTop: '5px'}}>
                  <Typography variant="body1"  className={classes.productPriceText}>
                    Rp {(productDetail.bundlingData as any).bundlingPrice1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                  </Typography>
                </Box>
                <div className={classes.productDescription}>
                  <Typography className={classes.productSubtitle}>
                    HARGA BUNDLING<span style={{
                      fontStyle: 'italic',
                      fontWeight: 300,
                      color: '#787878',
                      fontSize: '11px',
                      marginLeft: '8px',
                      letterSpacing: '0.5px',
                      verticalAlign: 'middle',
                    }}>Beli 2, Lebih Murah!</span>
                  </Typography>
                  <Box style={{
                    padding: '9px 11px',
                    border: '1px solid rgb(207,207,207)',
                    borderRadius: '17px',
                  }}>
                    {
                      productDetail.bundlingData.bundlingPrice2 === productDetail.bundlingData.bundlingPrice3 ?
                      <Grid container>
                        <Grid item xs={6} style={{borderRight: '1px solid rgb(207,207,207)'}}>
                          <Box style={{display: 'flex', alignItems: 'center'}}>
                            <Typography style={{color: '#fff', backgroundColor: '#121212', padding: '3px 6px 1px', borderRadius: '10px', fontSize: '9px'}}>1 PCS</Typography>
                            <Typography style={{marginLeft: '4px', fontWeight: 600, fontSize: '8px'}}>HARGA AWAL</Typography>
                          </Box>
                          <Typography style={{
                            fontSize: '17px',
                            fontWeight: 600,
                            color: '#121212',
                            fontFamily: 'Open sans, sans-serif'}}>
                            Rp {(productDetail.bundlingData as any).bundlingPrice1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Box style={{marginLeft: '7%', display: 'flex', alignItems: 'center'}}>
                            <Typography style={{color: '#fff', backgroundColor: '#121212', padding: '3px 6px 1px', borderRadius: '10px', fontSize: '9px'}}>2+ PCS</Typography>
                            <Typography style={{marginLeft: '4px', fontWeight: 600, fontFamily: 'Open sans, sans-serif', fontSize: '9px', color: 'red', textDecoration: 'line-through'}}>Rp {(productDetail.bundlingData as any).bundlingPrice1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}</Typography>
                          </Box>
                          <Typography style={{
                            marginLeft: '7%', 
                            fontSize: '17px',
                            fontWeight: 600,
                            color: '#121212',
                            fontFamily: 'Open sans, sans-serif'}}>
                            Rp {(productDetail.bundlingData as any).bundlingPrice2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                        </Grid>
                      </Grid>:
                      <Grid container>
                        <Grid item xs={4} style={{borderRight: '1px solid rgb(207,207,207)'}}>
                          <Box style={{display: 'flex', alignItems: 'center'}}>
                            <Typography style={{color: '#fff', backgroundColor: '#121212', padding: '3px 6px 1px', borderRadius: '10px', fontSize: '9px'}}>1 PCS</Typography>
                            <Typography style={{marginLeft: '4px', fontWeight: 600, fontSize: '8px'}}>HARGA AWAL</Typography>
                          </Box>
                          <Typography style={{
                            fontSize: '17px',
                            fontWeight: 600,
                            color: '#121212',
                            fontFamily: 'Open sans, sans-serif'}}>
                            Rp {(productDetail.bundlingData as any).bundlingPrice1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} style={{borderRight: '1px solid rgb(207,207,207)'}}>
                          <Box style={{marginLeft: '6%', display: 'flex', alignItems: 'center'}}>
                            <Typography style={{color: '#fff', backgroundColor: '#121212', padding: '3px 6px 1px', borderRadius: '10px', fontSize: '9px'}}>2 PCS</Typography>
                            <Typography style={{marginLeft: '4px', fontWeight: 600, fontFamily: 'Open sans, sans-serif', fontSize: '9px', color: 'red', textDecoration: 'line-through'}}>Rp {(productDetail.bundlingData as any).bundlingPrice1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}</Typography>
                          </Box>
                          <Typography style={{
                            marginLeft: '6%', 
                            fontSize: '17px',
                            fontWeight: 600,
                            color: '#121212',
                            fontFamily: 'Open sans, sans-serif'}}>
                            Rp {(productDetail.bundlingData as any).bundlingPrice2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Box style={{marginLeft: '6%', display: 'flex', alignItems: 'center'}}>
                            <Typography style={{color: '#fff', backgroundColor: '#121212', padding: '3px 6px 1px', borderRadius: '10px', fontSize: '9px'}}>3+ PCS</Typography>
                            <Typography style={{marginLeft: '4px', fontWeight: 600, fontFamily: 'Open sans, sans-serif', fontSize: '9px', color: 'red', textDecoration: 'line-through'}}>Rp {(productDetail.bundlingData as any).bundlingPrice1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}</Typography>
                          </Box>
                          <Typography style={{
                            marginLeft: '6%', 
                            fontSize: '17px',
                            fontWeight: 600,
                            color: '#121212',
                            fontFamily: 'Open sans, sans-serif'}}>
                            Rp {(productDetail.bundlingData as any).bundlingPrice3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                        </Grid>
                      </Grid>
                    }
                  </Box>
                  <Typography className={classes.restockInfoText} style={{fontSize: '11px'}}>
                    <span className={classes.restockInfoTextIcon} style={{marginRight: '5px', fontSize: '11px'}}>&#x24D8;</span> Bisa mix / dikombinasi dengan <b>{productDetail.bundlingData.bundlingName} lainnya!</b>
                  </Typography>
                </div> 
                </>
                : 
                discountedPrice === -1 || isSoldOut || productDetail.isComingAgainSoon
                ?
                <Box className={classes.priceBox}>
                  <Typography variant="body1"  className={classes.productPriceText}>
                    Rp {originalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                  </Typography>
                </Box> 
                : 
                <Box className={classes.priceBox}>
                  <Typography variant="body1"  className={classes.productPriceText}>
                    Rp {discountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                  </Typography>
                  <Typography variant="body1"  className={classes.productPriceTextDiscountStrikeThrough}>
                    Rp {originalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                  </Typography>
                </Box>
              }
              

              {
                productDetail.bundlingData ? 
                null :
                productDetail.stockAvailType === "LimitedStock-1" ? 
                <Box className={classes.limitedStockBubbleBox}>
                  <Typography className={classes.limitedStockBubbleText}>
                    LIMITED STOCK
                  </Typography>
                </Box>:
                productDetail.stockAvailType === "RoutineRestock-1" ? 
                null:
                <Box className={classes.limitedStockBubbleBox}>
                  <Typography className={classes.limitedStockBubbleText}>
                    LIMITED STOCK
                  </Typography>
                </Box>
              }
              {
                productDetail.stockAvailType === "RoutineRestock-1" ?
                (
                  productReviewsState.productId + "" !== reviewProductId + "" ?
                  <div className={classes.productRating}>
                    <Typography className={classes.productDescriptionText}>
                      Loading reviews..
                    </Typography>
                  </div>:
                  productReviewsState.reviews.length === 0 || productReviewsState.averageStars === undefined ? 
                  <div className={classes.productRating}>
                    <Typography className={classes.productDescriptionText}>
                      No ratings yet
                    </Typography>
                  </div> : 
                  <div className={classes.productRating}>
                    <StarsElement stars={productReviewsState.averageStars} />
                    <Typography className={classes.productDescriptionText}>
                      {productReviewsState.reviews.length + " Ratings"}
                    </Typography>
                  </div> 
                ):
                null
              }
              
              {
                productDetail.bundlingData ? null :
                !isSoldOut && numberOfItemsRemaining && numberOfItemsRemaining < 14 ?
                <Box className={classes.sisaBoxInDetail}>
                  <Typography className={classes.sisaTextInDetail}>
                    Sisa {numberOfItemsRemaining}
                  </Typography>
                </Box>:
                null
              }

              {
                isSoldOut ? 
                <div className={classes.productLeftInStock}>
                  <Typography variant="body1"  className={classes.productLeftInStockText}>
                    SOLD OUT
                  </Typography>
                </div>:
                productDetail.isComingAgainSoon 
                //|| productDetail.productBackendVersion !== "v3.0" 
                ? 
                <div className={classes.productLeftInStock}>
                  <Typography variant="body1"  className={classes.productLeftInStockText}>
                    COMING BACK SOON
                  </Typography>
                </div>:
                null
              }

              {
                productVariantsList && productVariantsList.length > 0 ? (
                  <div
                    style={{margin: '20px 0px 20px 0px'}}
                  >
                    <Typography className={classes.productSubtitle}>
                      PILIH VARIAN WARNA
                    </Typography>
                    <PageProductDetailVariantOptions
                      productVariantsList={productVariantsList}
                      currentProductId={productDetail.productId}
                    />
                  </div>
                ) :
                null
              }

              {
                productDetail?.multiDescriptionData?.length && productDetail.multiDescriptionData.length > 0 ?
                <div style={{ width: '100%' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    {productDetail.multiDescriptionData.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          padding: '5px 6px 12px',
                        }}
                        onClick={() => setSelectedReviewTab(index)}
                      >
                        <Typography style={{
                          fontWeight: 600,
                          fontSize: '13px',
                          letterSpacing: '0.6px',
                          color: index === selectedReviewTab ? '#121212' : '#676767',
                          textDecoration: index === selectedReviewTab ? 'underline' : '',
                          textUnderlineOffset: '5px',
                          textDecorationThickness: '1.2px',
                          cursor: 'pointer',
                        }}>{item.tabTitle}</Typography>
                      </div>
                    ))}
                  </div>
                  
                  <div
                   style={{ 
                    width: '100%', 
                    height: 'fit-content',
                    position: 'relative',
                     }}>
                        {productDetail.multiDescriptionData.map((item, index) => (
                          <Fade key={index} in={index === selectedReviewTab} timeout={300}>
                            <div
                              style={{
                                width: '100%',
                                color: 'grey',
                                display: index === selectedReviewTab ? 'block' : 'none',
                              }}
                            >
                              {item.tabType === 'DESCRIPTION' && (
                                item.tabData.map((subItem: {} | null | undefined, subIndex: React.Key | null | undefined) => {
                                  if (typeof subItem === 'string') {
                                    return (
                                      <div key={subIndex}>
                                        <Typography className={classes.productDescriptionText} style={{
                                          marginBottom: '1px',
                                        }}>{subItem}</Typography>
                                      </div>
                                    );
                                  } else if (Array.isArray(subItem)) {
                                    return (
                                      <div key={subIndex}>
                                        <ul style={{
                                          marginTop: '10px',
                                          marginBottom : '23px',
                                        }}>
                                          {subItem.map((listItem, listItemIndex) => (
                                            <li key={listItemIndex}>
                                              <Typography className={classes.productDescriptionText} 
                                              style={{
                                                marginBottom: '5px',
                                              }}>{listItem}</Typography>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    );
                                  }
                                  return null;
                                })
                              )}
                              {item.tabType === 'DETAILLIST' && (
                                <Grid container
                                  style={{
                                    marginTop: '6px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'flex-start',
                                    width: '100%',
                                    flexWrap: 'wrap',
                                    background: 'lightred'
                                  }}
                                >
                                  {item.tabData.map((detailItem: any, detailItemIndex: React.Key | null | undefined) => (
                                    <Grid item xs={6}
                                      key={detailItemIndex}
                                      style={{
                                      }}
                                    >
                                      {/* Hacky workaround ts */}
                                      <Typography className={classes.productDescriptionText} style={{
                                        fontWeight: 600,
                                        letterSpacing: '0px',
                                        marginBottom: '0px',
                                      }}>{detailItem.title}</Typography> 
                                      <Typography className={classes.productDescriptionText} style={{
                                        fontWeight: 300,
                                        fontStyle: 'italic',
                                        color: '#757575',
                                        marginBottom: '19px',
                                        letterSpacing: '0.2px',
                                      }}>{detailItem.text}</Typography>
                                    </Grid>
                                  ))}
                                </Grid>
                              )}
                            </div>
                          </Fade>
                        ))}
                  </div>
                </div>
                :
                <div className={classes.productDescription}>
                  <Typography className={classes.productSubtitle}>
                    DESKRIPSI
                  </Typography>
                  <Typography variant="body1"  className={classes.productDescriptionText}>
                    {
                      ReactHtmlParser(productDetail.description)
                    }
                  </Typography>
                </div>
              }
              {
                streamIsOn &&
                <Box style={{
                  borderRadius: '300px',
                  border: '1px solid rgb(200, 200, 200)',
                  margin: '-2px 0px 16px',
                  padding: '6px 8px 4px 12px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'relative',
                  width: 'fit-content',
                }} onClick={() => {
                  dispatch(sendLivestreamMessage("UD-User tanya bahan produk " + productDetail.name));
                  dispatch(setLivestreamDialog('LIVE'));
                }}>
                  <LiveLogoMobile styleAdd={{
                    position: 'absolute',
                    top: '-14px',
                    left: '3px'
                  }}/>
                  <Typography style={{padding: '1px 5px 0px 5px', fontSize: '12px', letterSpacing: '0.2px', fontWeight: 600}}>TANYA SOAL BAHAN</Typography>
                  <ArrowRight style={{marginLeft: '-8px', paddingBottom: '2px'}}/>
                </Box>
              }
              {
                userIsSignedInAndHasPurchased ? 
                null :
                isDesktop ?
                null :
                <div className={classes.sectionDescriptionSegmentOut} style={{
                  marginTop: '10px',
                  marginBottom: '21px'
                }}>
                  <video autoPlay muted playsInline loop
                  src={'https://studiosclo.uk/general/web-general-intro-horizontal-1.mp4'} style={{
                    width: '100%',
                    aspectRatio: '3',
                  }}/>
                </div>
              }
              <div className={classes.ukuranRegulerBox} id='ukuran-reguler-box'>
                <Typography className={classes.productSubtitle}>
                  UKURAN REGULER
                </Typography>
                <Typography className={classes.ukuranRegulerBoxSizeChartLink}
                onClick={() => {
                  dispatch(updateSizeChartClothFitType({
                    clothingType: clothingType,
                    fitType: fitType
                  }));
                  dispatch(openOverlaySizeChart());
                  sendWebsiteEventMessage("User opens size chart");
                }}>
                  + LIHAT SIZE CHART
                </Typography>
                <Box className={classes.ukuranRegulerSizeTextBox} id='size-reguler-list' onClick={handleClickSizeBar}>
                  {
                    ["XXS", "XS", "S", "M", "L", "XL", "XXL"].map((value, index) => {
                      const ukuranAda = productSizeAvailabilityDict?.[productId]?.availabilityArray?.[index];
                      return (
                        <Typography className={ ukuranAda ? classes.ukuranRegulerSizeTextAda : classes.ukuranRegulerSizeTextHabis }>
                          {value}
                        </Typography>
                      );
                    })
                  }
                </Box>
                {
                  productDetail.extraSizeChargePrice ? 
                  <Grid container onClick={handleClickSizeBar} style={{
                    padding: '5px 12px',
                    marginTop: '8px',
                    border: '1px solid rgb(194,194,194)',
                    borderRadius: '30px'
                    // display: "flex",
                    // flexDirection: "row",
                    // justifyContent: "space-between",
                    // marginTop: "1vw",
                    // paddingLeft: "0.4vw",
                    // paddingRight: "0.4vw",
                    // [theme.breakpoints.down('xs')]: {
                    //   marginTop: "4vw",
                    // }
                  }}>
                    <Grid item xs={7} style={{display: 'flex', alignItems: 'center'}}>
                      <Typography style={{
                        fontSize: '8px',
                        padding: '2px 6px 0px',
                        marginRight: '7px',
                        border: '1px solid rgb(6, 37, 158)',
                        borderRadius: '40px',
                        color: 'rgb(6, 37, 158)',
                        height: 'fit-content'
                      }}>PLUS</Typography>
                      <Typography style={{
                        fontSize: '12px',
                        marginRight: '5px',
                        paddingTop: '2px',
                        fontWeight: 500,
                      }}>
                        Plus Size
                      </Typography>
                      <Typography style={{
                        fontSize: '11px',
                        fontWeight: 300,
                        color: '#232323',
                        paddingTop: '2px',
                      }}>
                        + Rp {(productDetail?.extraSizeChargePrice ?? 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </Typography>
                    </Grid>
                    <Grid item xs={5} style={{
                      display: 'flex',
                      justifyContent: "space-between",
                      paddingTop: '2px',
                    }}>
                      {
                        // WE DON'T SHOW 8XL OPTION HERE. TOO TIGHT.
                        ["3XL", "4XL", "5XL", "6XL", "7XL"].map((value, index) => {
                          const ukuranAda = productSizeAvailabilityDict?.[productId]?.availabilityArray?.[index + 7];
                          return (
                            <Typography className={ ukuranAda ? classes.ukuranRegulerSizeTextAda : classes.ukuranRegulerSizeTextHabis }>
                              {value}
                            </Typography>
                          );
                        })
                      }
                    </Grid>
                  </Grid>:
                  null
                }
                <Typography className={classes.talentInfoText} id='talent-info-text'>
                  Talent tinggi 175 cm dan berat 76 kg, memakai size L.
                </Typography>
                <Typography className={classes.restockInfoText}>
                  <span className={classes.restockInfoTextIcon}>&#x24D8;</span>
                  {
                    productDetail.stockAvailType === "LimitedStock-1" ? 
                    "Tidak ada restock untuk item ini / limited restock." :
                    productDetail.stockAvailType === "RoutineRestock-1" ? 
                    "Jika ukuran habis, produk restock ":
                    "Tidak ada restock untuk item ini."
                  }
                  {
                    productDetail.stockAvailType === "LimitedStock-1" ? 
                    null :
                    productDetail.stockAvailType === "RoutineRestock-1" ? 
                    <span className={classes.restockInfoTextHighlight}>
                      est. {(productDetail.stockRestockTime ? productDetail.stockRestockTime : "7-8 minggu")}
                    </span>:
                    null
                  }
                  {
                    productDetail.stockAvailType === "LimitedStock-1" ? 
                    null :
                    productDetail.stockAvailType === "RoutineRestock-1" ? 
                    " lagi":
                    null
                  }
                </Typography>
                
              </div>
              {
                streamIsOn &&
                <Box style={{
                  borderRadius: '300px',
                  border: '1px solid rgb(200, 200, 200)',
                  margin: '-2px 0px 16px',
                  padding: '6px 8px 4px 12px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'relative',
                  width: 'fit-content',
                }} onClick={() => {
                  dispatch(sendLivestreamMessage("UD-User tanya size produk " + productDetail.name));
                  dispatch(setLivestreamDialog('LIVE'));
                }}>
                  <LiveLogoMobile styleAdd={{
                    position: 'absolute',
                    top: '-14px',
                    left: '3px'
                  }}/>
                  <Typography style={{padding: '1px 5px 0px 5px', fontSize: '12px', letterSpacing: '0.2px', fontWeight: 600}}>TANYA SIZE</Typography>
                  <ArrowRight style={{marginLeft: '-8px', paddingBottom: '2px'}}/>
                </Box>
              }
              {
                currentSelectedMeasurement !== undefined ? 
                <div id='pilih-ukuran-segment-header'>
                  <Typography className={classes.productSubtitle} onClick={() => {
                    dispatch(postCanAddItemCount(cartStateItem)); // HIDDEN REFETCH
                  }}>
                    UKURAN KAMU
                  </Typography>
                  <SizeSelection clothingType={clothingType} fitType={fitType} 
                    productDetail={productDetail}
                    needsServiceabilityAdjustment={productPurchaseStage === 'NOT_SERVICEABLE'}
                    handleClick={() => {
                        dispatch(postNewProductAnalyticsLog({event: 'SELECT-SIZE', productId: productId, isMobileView: !isDesktop }))
                      }
                    }
                    productPurchaseStage={productPurchaseStage}
                    handleInstantATCViewPakai={handleAddToCartMainButton}
                  />
                </div>:
                userIsSignedInAndHasPurchased && !hasUkuranPersonal && clothMeasSuggestions?.length ? // DIVIDE INTO 2 CASES
                <div id='pilih-ukuran-segment-header'>
                  <Typography className={classes.productSubtitle}>
                    PAKAI UKURAN CUSTOM SEBELUMNYA
                  </Typography>
                  <Box>
                    <UkuranBadanSegment
                    clothingType={clothingType}
                    fitType={fitType}
                    productDetail={productDetail}
                    singleSelectedBodyMeasurement={{adjustedMeasurements: clothMeasSuggestions[0].clothMeasValue}}
                    singleSelectedBodyMeasurementCreationDateTime={clothMeasSuggestions[0].purchaseDateString}
                    closeParentFunction={() => {
                    }}
                    useZeroInstallView={true}
                    useZeroInstallInformation={{
                      productImage: clothMeasSuggestions[0].productDisplayImage,
                      productName: clothMeasSuggestions[0].productName,
                    }}
                    productPurchaseStage={""}/>
                  </Box>
                </div>:
                // userIsSignedInAndHasPurchased && !hasUkuranPersonal && !clothMeasSuggestions?.length ? // DIVIDE INTO 2 CASES
                // <div id='pilih-ukuran-segment-header'>
                //   {/* AJAKAN BUAT DISINI */}
                //   <Typography className={classes.productSubtitle}>
                //     PILIH UKURAN & BELI
                //   </Typography>
                //   <Typography className={classes.pilihUkuranSubtext}>
                //     {"Tersedia ukuran reguler, atau ada ukuran custom."}
                //   </Typography>
                // </div>:
                <div id='pilih-ukuran-segment-header'>
                  <Typography className={classes.productSubtitle}>
                    PILIH UKURAN & BELI
                  </Typography>
                  <Typography className={classes.pilihUkuranSubtext}>
                    {"Tersedia ukuran reguler, atau ada ukuran custom."}
                  </Typography>
                </div>
              }
              {
               currentSelectedMeasurementIsBody ? 
               <Box style={{width: '100%', display: 'flex', justifyContent: 'center', margin: '9px 0px 16px'}} onClick={() => {
                dispatch(closeOverlayAndResetSelection());
                dispatch(setValuesSelection({
                  clothingType: clothingType,
                  fitType: fitType,
                  isFullScreen: false,
                  productDetail: productDetail ?? undefined,
                }))
                dispatch(openOverlaySelection());
               }}>
                <Typography style={{fontSize: '10px', color: 'rgb(66, 66, 66)', fontWeight: 400, textDecoration: 'underline', textUnderlineOffset: '4px'}}>Atau, Pilih Ukuran Lainnya →</Typography>
               </Box>:
              // userIsSignedInAndHasPurchased && !hasUkuranPersonal ? 
              // <Box style={{width: '100%', display: 'flex', justifyContent: 'center', margin: '9px 0px 16px'}} 
              // // disabled={isSoldOut || productDetail.isComingAgainSoon
              // //   || (currentSelectedMeasurement !== undefined && canAddProductAmountToCart(cart, cartStateItem) !== "ENOUGH")
              // //   || postMeasurementStatus === APIRequestStatus.RequestInProgress}
              // onClick={handleAddToCartMainButton}>
              //  <Typography style={{fontSize: '10px', color: 'rgb(66, 66, 66)', fontWeight: 400, textDecoration: 'underline', textUnderlineOffset: '4px'}}>Atau, Buat Ukuran Baru +</Typography>
              // </Box>:
              <FareastButton
                buttonMarginTopBottom='10px'
                buttonMarginLeftRight='0px'
                // Ensure isOfflineSession doesn't accidentally trigger "disabled" logic if you had specific checks
                disabled={((isSoldOut || productDetail.isComingAgainSoon) && productPurchaseStage !== "ADD_TO_CART")
                  || (currentSelectedMeasurement !== undefined && canAddProductAmountToCart(cart, cartStateItem) !== "ENOUGH")
                  || postMeasurementStatus === APIRequestStatus.RequestInProgress}
                variant="contained"
                aria-label="add to cart"
                fullWidth
                onClick={handleAddToCartMainButton}
              >
                <Typography className={classes.addToCartButtonText} id='text-add-to-cart'>
                  {
                    postMeasurementStatus === APIRequestStatus.RequestInProgress ?
                    "LOADING..." :
                    productPurchaseStage === "PILIH_UKURAN" ? 
                    "PILIH UKURAN & BELI PRODUK" :
                    productPurchaseStage === "UNDEFINED_ITEM" ?
                    "UNDEFINED ITEM" :
                    productPurchaseStage === "CHECKING_STOCK" ? 
                    "CHECKING STOCK..." :
                    productPurchaseStage === "ADD_TO_CART" ?
                    "ADD TO CART" :
                    productPurchaseStage === "NOT_SERVICEABLE" ?
                    "UKURAN BUTUH PENYESUAIAN" :
                    (
                      currentSelectedMeasurement?.sizeType === 'personal' ? 
                      "BAHAN TIDAK CUKUP UNTUK UKURAN" : 
                      "STOK HABIS"
                    )
                  }
                </Typography>
              </FareastButton>
              }
              {
                isSignedIn ?
                null : 
                <SignUpSignInLink 
                isSignUp={true}
                handleClick={(isSignUp) => {
                  if (isSignUp) {
                    dispatch(openOverlay());
                    dispatch(updateSignUpOrSignIn('signIn'))
                  } else {
                    dispatch(openOverlay());
                    dispatch(updateSignUpOrSignIn('signUp'))
                  }
                }}/>
              }
              <div className={classes.marketplaceContainer}>
                <Typography className={classes.productSubtitle} style={{marginBottom: '10px'}}>
                  {marketplaceLinkDataList.length > 0 ? 'TERSEDIA JUGA DI' : 'OPSI PEMBELIAN'}
                </Typography>
                {
                  marketplaceLinkDataList.length > 0 ? (
                    <div className={classes.marketplaceItemRowContainer} style={{gap: marketplaceLinkDataList.length === 2 ? '10px' : marketplaceLinkDataList.length === 3 ? '5px' : '0px'}}>
                      {
                        marketplaceLinkDataList.map(key => 
                          <div 
                            key={key}
                            className={classes.marketplaceItemContainer}
                            onClick={() => {
                              sendWebsiteEventMessage("User MARKETPLACE CLICK: " + key + " produk " + productDetail.productId);

                              if ((window as any).fbq !== null) { 
                                (window as any).fbq('track', 'AddToCart', {
                                  content_ids: [productDetail.productId],
                                  content_type: 'product',
                                  contents: [{
                                    id: productDetail.productId,
                                    quantity: 1,
                                  }],
                                  currency: "IDR",
                                  value: Math.round((productDetail.discountedPrice === -1 ? productDetail.originalPrice : productDetail.discountedPrice) * 0.7), // Multiplication factor
                                })
                              };

                              dispatch(openOverlayMarketplaceStart({
                                "chosen": marketplaceLinkData[key],
                                "chosenKey": key,
                                ...marketplaceLinkData
                              }));
                              // window.open(marketplaceLinkData[key], '_blank');

                              // (window as any).hj('event', 'start_hotjar_rec'); // START HOTJAR REC
                              // sendWebsiteLivestreamMessage('[HOTJAR REC - UX] STARTED - MKTPLC IN PRODUCT DETAIL POPUP');
                            }}
                          >
                            <img
                              key={key} 
                              src={marketplaceLogoDictionary[key as keyof typeof marketplaceLogoDictionary]}
                              className={classes.marketplaceLogo}
                              alt={`${key} logo`}
                            />
                            <Typography className={classes.marketplaceText} style={{fontSize: marketplaceLinkDataList.length === 3 ? '10px' : undefined, marginTop: isDesktop ? '0.3vw' : '1vw'}}>
                              {key.toUpperCase()}
                            </Typography>
                          </div>
                        )
                      }
                    </div>
                  ) : (
                    <div className={classes.exclusiveItemContainer}>
                      <img src={process.env.PUBLIC_URL + '/assets/icon-web.png'} style={{width: '20px', marginBottom: '2.5px'}}/>
                      <Typography className={classes.marketplaceText} style={{fontSize: '12px' }}>
                        EKSKLUSIF DI WEB STUDIO S.
                      </Typography>
                    </div>
                  )
                }
                {
                  marketplaceLinkDataList.length > 0 ?
                  <div>
                    <Typography style={{
                      textAlign: 'center',
                      fontWeight: '300',
                      color: '#AFAFAF',
                      fontSize: '11px',
                      marginTop: '15px',
                      letterSpacing: '0.2px',
                    }}>
                      ⓘ Ukuran custom hanya tersedia di Website Studio S.
                    </Typography>
                  </div>:
                  null
                }
              </div>
          </Box>
        </Grid>
      </Box>

      {
        userIsSignedInAndHasPurchased ? 
        null :
        isDesktop ?
        <div style={{
          width: '100%',
          marginTop: '36px',
          marginBottom: '21px',
          backgroundColor: 'rgb(10,10,10)',
          display: 'flex',
          justifyContent: 'center',
        }}>
          <video autoPlay muted playsInline loop
          src={'https://studiosclo.uk/general/web-general-intro-horizontal-1.mp4'} style={{
            width: '50%',
            aspectRatio: '3',
            borderRadius: '0px',
          }}/>
        </div>:
        null
      }

      {
        userIsSignedInAndHasPurchased && !isDesktop ? 
        null //<ReferralComponent />
        : null
      }

      {/* Review Haidar */}
      
      <Box className={classes.categoryReviewContainer} id='product-review-container'>
        <Box className={classes.categoryReviewContent} 
          onClick={() => handleOpenDialogSeeAllReview()}>
          <Typography className={classes.categoryReviewContentTitle}>
            REVIEW UNTUK {productCategoryForReviewName}
          </Typography>
          <ReviewComponent 
            ratingNumber={productCategoryReviewRecap[productCategoryForReview]?.numberOfRatings} 
            ratingValue={productCategoryReviewRecap[productCategoryForReview]?.averageRating}
            categoryName={productCategoryForReviewName}
          />
        </Box>

        {
          productCategoryReviewList && productCategoryReviewList.length > 0 &&
          <div>
              <ReviewSliderImage reviews={shortenedReviewList} onClickImage={(reviewIndex: number, imageIndex: number) => handleOpenDialogReviewImage(reviewIndex, imageIndex)}/>

              <ReviewSlider reviews={shortenedReviewList} onClickContent={() => handleOpenDialogSeeAllReview()} onClickImage={(reviewIndex: number, imageIndex: number) => handleOpenDialogReviewImage(reviewIndex, imageIndex)}/>

              <Box className={classes.categoryReviewButtonContainer}>
                <Box 
                className={classes.categoryReviewButtonSeeAll}
                onClick={() => handleOpenDialogSeeAllReview()}
                >
                  <Typography className={classes.categoryReviewButtonSeeAllText}>
                    LIHAT SEMUA REVIEW ({productCategoryReviewRecap[productCategoryForReview]?.numberOfRatings} REVIEW)
                  </Typography>
                </Box>
              </Box>

              <ReviewDialogImage
                open={openDialogReviewImage}
                onClose={handleCloseDialogReviewImage}
                reviews={fullReviewList}
                initialReviewIndex={selectedReviewIndex}
                initialImageIndex={selectedImageIndex}
              />

              <ReviewDialog
                  open={openDialogSeeAllReview}
                  onClose={handleCloseDialogSeeAllReview}
                  categoryName={productCategoryForReviewName}
                  ratingValue={productCategoryReviewRecap[productCategoryForReview]?.averageRating}
                  ratingNumber={productCategoryReviewRecap[productCategoryForReview]?.numberOfRatings}
                  reviews={fullReviewList}
                  onClickImage={(reviewIndex: number, imageIndex: number) => handleOpenDialogReviewImageFromReviewDialog(reviewIndex, imageIndex)}
              />
          </div>
          
        }
      </Box>
     
      {/* Review Haidar */}

      <PageProductOverlayNewReview 
        productId={reviewProductId}
        newReviewOverlayOpen={newReviewOverlayOpen}
        setNewReviewOverlayOpen={setNewReviewOverlayOpen} />
      <PageProductOverlaySizeChart />
      <PageProductOverlayImageCarousel 
        updateNextAutoslideTime={() => {
          const autoslideFreezeTime = 9; // In seconds
          nextAutoslideTime.current = new Date(new Date().getTime() + (autoslideFreezeTime * 1000)).toISOString();
        }}
        imageOverlayIndex={imageOverlayIndex}
        setImageOverlayIndex={setImageOverlayIndex}
        imageOverlayOpen={imageOverlayOpen} 
        setImageOverlayOpen={setImageOverlayOpen}
        productImages={productImagesList.map((urlImg) => urlImg.replace('_familymedia', '').replace('.jpg', '').replace('.jpeg', '') + (urlImg.includes('mp4') ? '' : '_1080.jpg'))} />
      
      {
        isDesktop ? 
        <img
          alt="svg-sla"
          src='https://studiosclo.uk/legacy/SLA_September2023_D.svg'
          className={classes.svgContentFullWidthDesktop}
        /> :
        <img
          alt="svg-sla"
          src='https://studiosclo.uk/legacy/SLA_Oktober2023_M.svg'
          className={classes.svgContentFullWidthMobile}
        />
      }

      <PageProductSuggestions seedNumber={getHash(productId + (new Date().toISOString()).substring(0, 15))} excludedProductId={productId}/>
    </Box>
  );
}


function sortProductCategoryReviewList(productCategoryReviewList: CategoryReview[] | undefined): CategoryReview[] {
  if (!productCategoryReviewList) {
    return [];
  }

  return productCategoryReviewList.sort((a, b) => {
    const aClass = a.reviewClass || 1;
    const bClass = b.reviewClass || 1;

    if (aClass !== bClass) {
      return aClass > bClass ? -1 : 1;
    }

    return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
  });
}

  interface ProductVariant {
    variantName: string;
    variantPath: string;
    variantDisplayImage: string;
  }
  

  const productVariantsListDummy: ProductVariant[] = [
    {
      variantName: 'Jet Black',
      variantPath: '2024-11-PoloWaffle-TexturedPoloShirtinBlack',
      variantDisplayImage: 'https://studiosclo.uk/product-image/2024-11-PoloWaffle-TexturedPoloShirtinBlack/Waffle-Polo-Black-Midshot.jpg',
    
    },
    {
      variantName: 'Navy Blue',
      variantPath: '2024-11-PoloWaffle-TexturedPoloShirtinNavyBlue',
      variantDisplayImage: 'https://studiosclo.uk/product-image/2024-11-PoloWaffle-TexturedPoloShirtinNavyBlue/Waffle-Polo-Blue-Midshot.jpg',
  
    },
    {
      variantName: 'Copper Brown',
      variantPath: '2024-11-PoloWaffle-TexturedPoloShirtinCopperBrown',
      variantDisplayImage: 'https://studiosclo.uk/product-image/2024-11-PoloWaffle-TexturedPoloShirtinCopperBrown/Waffle-Polo-Brown-Midshot.jpg',
    
    },
    {
      variantName: 'Hunter Green',
      variantPath: '2024-11-PoloWaffle-TexturedPoloShirtinHunterGreen',
      variantDisplayImage: 'https://studiosclo.uk/product-image/2024-11-PoloWaffle-TexturedPoloShirtinHunterGreen/Waffle-Polo-Green-Midshot.jpg',
   
    },
  ];